import request from '@/utils/request'

/**
 * @param {import('@/types/generated/openapi').paths['/event/log']['get']['parameters']['query']} params
 */
export function featchMessageLog(params) {
  return request({
    url: 'event/log',
    method: 'get',
    params
  })
}

export function featchMessageLogDetail(id) {
  return request({
    url: `event/log/${id}`,
    method: 'get'
  })
}

/** 获取事件日志详情 */
export function getEventLogDetail(id) {
  return request({
    url: `/event/log/${id}`,
    method: 'get'
  })
}

/**
 * ntc告警数量
 * @param {import('@/types/generated/openapi').paths['/event/log-statistic']['get']['parameters']['query']} params
 */
export function getNTCEventLogStatistic(params) {
  return request({
    url: `/event/log-statistic`,
    method: 'get',
    params: params
  })
}

/**
 * 【事件日志】提交异步导出任务
 * @param {import('@/types/generated/openapi').paths['/event/log/export-async']['post']['parameters']['query']} params
 */
export function submitEventLogExportAsyncTask(params) {
  return request({
    url: `event/log/export-async`,
    method: 'post',
    params
  })
}
